import {FC, Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'

// One Suspense boundary for every code-split page (ADR-0022): while a page's
// chunk loads the shell stays put and a thin progress bar runs along the top
// of the window, as Metronic's own lazy modules do.
const configureProgressBar = () => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {'0': baseColor},
    barThickness: 1,
    shadowBlur: 5,
  })
}

const PageLoading: FC = () => {
  configureProgressBar()
  return (
    <>
      <TopBarProgress />
      <div role='progressbar' aria-busy='true' data-testid='page-loading' className='visually-hidden' />
    </>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => (
  <Suspense fallback={<PageLoading />}>{children}</Suspense>
)

// A pathless layout route whose children are the lazy pages.
const LazyOutlet: FC = () => (
  <SuspensedView>
    <Outlet />
  </SuspensedView>
)

export {SuspensedView, PageLoading, LazyOutlet}
